import { ChangeEvent } from 'react'

interface ConsentCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  error?: string
}

export function ConsentCheckbox({
  checked,
  onChange,
  error,
}: ConsentCheckboxProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked)
  }

  return (
    <div className='mt-4 flex justify-center'>
      <label className='flex items-start gap-x-3 cursor-pointer'>
        <input
          type='checkbox'
          checked={checked}
          onChange={handleChange}
          className='mt-1 h-4 w-4 rounded border-gray-300 text-dw-gold focus:ring-dw-gold'
        />
        <span className='text-sm text-gray-700'>
          I agree to the{' '}
          <a
            href='https://www.webwisdom.ai/terms-of-service'
            target='_blank'
            rel='noopener noreferrer'
            className='text-dw-gold hover:text-dw-yellow-accent underline'
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href='https://www.webwisdom.ai/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            className='text-dw-gold hover:text-dw-yellow-accent underline'
          >
            Privacy Policy
          </a>
        </span>
      </label>
      {error && (
        <div className='mt-2 text-red-500 text-sm text-left'>{error}</div>
      )}
    </div>
  )
}
